import React, { useState } from "react";
import dynamic from "next/dynamic";
const Empty = dynamic(() => import("antd/es/empty"), { ssr: false });
const Collapse = dynamic(() => import("antd/es/collapse"), { ssr: false });
const Space = dynamic(() => import("antd/es/space"), { ssr: false });
import CommonImage from "@/components/common/image/CommonImage";
import { FaFileAlt, FaPlay } from "react-icons/fa";
import Image from "next/image";
import { FaFilePdf } from "react-icons/fa6";
import PlayYoutubeModal from "@/components/common/Modal/PlayYoutubeModal";

export default function Syllabus({ course }) {
  console.log("course preview", course);
  const { Panel } = Collapse;
  const [modalOpen, setModalOpen] = useState(false);
  const [videoLink, setVideoLink] = useState(null);

  const openVideoModal = (link) => {
    setVideoLink(link);
    setModalOpen(true);
  };

  const [activeSubjectKey, setActiveSubjectKey] = useState(
    course?.subjects?.[0]?.id
  );

  const renderCourseSyllabus = () => (
    <Space direction="vertical" size={16} className="syllabus_accordions">
      {course?.modules?.map((module, modIndex) => (
        <Collapse
          key={module.id}
          accordion
          defaultActiveKey={modIndex === 0 ? [String(module.id)] : undefined}
          style={{ width: "100%", marginBottom: 16 }}
          items={[
            {
              key: String(module.id),
              label: (
                <span className="syllabus-label">
                  <div className="image-wrap">
                    <Image
                      src={
                        module.icon_url ??
                        "/images/admission-icon/book-icon-two.png"
                      }
                      alt="Syllabus Icon"
                      className="syllabus-icon"
                      width={40}
                      height={40}
                    />
                  </div>
                  {module.title}
                </span>
              ),
              children:
                module.materials?.length > 0 ? (
                  module.materials.map((item, index) => (
                    <div className="course_module_item_wrap" key={index}>
                      <div className="title-area">
                        {item.type == "2" ? (
                          <FaFilePdf className="icon" />
                        ) : item.type == "4" ? (
                          <FaFileAlt className="icon" />
                        ) : (
                          <FaPlay className="icon" />
                        )}
                        <span className="course_module_title">
                          {item.title}
                        </span>
                      </div>
                      <div className="lock_unlock">
                        { item.type == "1" && item.preview == "1" ? (
                          <span
                            onClick={() => openVideoModal(item.video_link)}
                            className="text-sm font-bold text-blue-600 cursor-pointer hover:underline"
                          >
                            ফ্রি ভিডিও
                          </span>
                        ) : (
                          <>
                            <CommonImage
                              src={`/images/course/${
                                item.preview == "1"
                                  ? "unlock.avif"
                                  : "lock.avif"
                              }`}
                              alt="Lock Icon"
                              className={"icon block [.dark_&]:hidden"}
                            />
                            <CommonImage
                              src={`/images/course/${
                                item.preview == "1"
                                  ? "d-unlock.avif"
                                  : "d-lock.avif"
                              }`}
                              alt="Lock Icon"
                              className={"icon hidden [.dark_&]:block"}
                            />
                          </>
                        )}
                      </div>
                    </div>
                  ))
                ) : (
                  <Empty
                    description={`No materials found for ${module?.title}`}
                  />
                ),
            },
          ]}
        />
      ))}
    </Space>
  );

  return (
    <div className="syllabus_section">
      <div className="title-wrap">
        <Image
          src="/images/admission-icon/syllabus-icon.png"
          alt="Price Tag"
          width={24}
          height={24}
        />
        <h2 className="title">কোর্স সিলেবাস</h2>
      </div>
      {course?.modules?.length > 0 ? renderCourseSyllabus() : <Empty />}
      <PlayYoutubeModal
        modalOpen={modalOpen}
        closeModal={() => setModalOpen(false)}
        link={videoLink}
      />
    </div>
  );
}
